export default class FilterBase {
    notification = null;
    callback = null;
    locale = null;
    settings = null;

    disabled = false;
    component = null;
    input = null;
    mainContainer = null;
    clearFilterButton = null;
    closeButton = null;

    inputs = [];
    checkboxes = [];
    checkAllCheckbox = null;
    selectedData = [];

    constructor(config, notification, componentId, disabledComponentKey = null) {
        this.notification = notification;
        this.component = document.getElementById(componentId);

        if (this.component !== null) {
            this.prepareConfig(config);
            this.prepareElements();
            this.setStatus(disabledComponentKey);
            this.bindInput();
            this.bindCloseModalOnBodyClick();
        }
    }

    setStatus = (disabledComponentKey) => {
        this.input.disabled = this.disabled = this.settings[disabledComponentKey] ?? false;
    }

    setCallback = (callback) => {
        this.callback = callback;
    }

    prepareConfig(config) {
        this.locale = config.locale;
        this.settings = config.settings;
    }

    prepareElements = () => {
        this.input = this.component.querySelector('.filter__input input');
        this.mainContainer = this.component.querySelector('.filter__container');
        this.clearFilterButton = this.component.querySelector('.filter-container__buttons .button--tetriary');
        this.closeButton = this.component.querySelector('.filter-container__buttons .button--primary');
        this.closeMobileButton = this.component.querySelector('.filter-container__header .close');
    }

    showContainer = () => {
        if (this.disabled) {
            this.notification.show(this.notification.types.error, this.locale.filterCannotBeEdited);
        } else {
            this.hideAllContainers();
            this.input.parentElement.classList.add('filter__input--selected');
            this.mainContainer.classList.add('filter__container--open');
        }
    }

    hideContainer = () => {
        this.input.parentElement.classList.remove('filter__input--selected');
        this.mainContainer.classList.remove('filter__container--open');
    }

    hideAllContainers = () => {
        document.querySelectorAll('.filter__input--selected').forEach(element => {
            element.classList.remove('filter__input--selected');
        });
        document.querySelectorAll('.filter__container--open').forEach(element => {
            element.classList.remove('filter__container--open');
        });
    }

    bindInput = () => {
        this.input.addEventListener('click', () => {
            this.showContainer();
        });
    }

    bindCloseButton = (callbackFunction) => {
        this.closeButton.addEventListener('click', () => {
            this.hideContainer();
            callbackFunction();
        });

        this.closeMobileButton.addEventListener('click', () => {
            this.hideContainer();
        });
    }

    bindClearFiltersButton = (callbackFunction) => {
        this.clearFilterButton.addEventListener('click', () => {
            callbackFunction();
        });
    }

    onCloseFilter = () => {
        if (this.callback !== null) {
            this.callback();
        }
    }

    onClearFilter = () => {
        this.selectedData.length = 0;
        if (this.checkAllCheckbox) {
            this.checkAllCheckbox.checked = false;
        }
        this.checkboxes.forEach(checkbox => {
            checkbox.checked = false;
        });
        this.inputs.forEach(input => {
            input.value = null;
        });
        this.updateInput();
    }

    bindCloseModalOnBodyClick = () => {
        this.mainContainer.addEventListener('click', (e) => {
            e.stopPropagation();
        });

        document.body.addEventListener('click', (e) => {
            if (
                e.target.parentElement !== null
                && e.target !== this.input
                && this.mainContainer.classList.contains('filter__container--open')
                && document.body.clientWidth > 900
            ) {
                this.mainContainer.classList.remove('filter__container--open');
                this.input.parentElement.classList.remove('filter__input--selected');
            }
        });
    }

    bindCheckAllCheckbox = () => {
        this.checkAllCheckbox.addEventListener('click', () => {
            this.checkboxes.forEach(checkbox => {
                checkbox.checked = this.checkAllCheckbox.checked;
                if (checkbox.checked) {
                    this.addItemToList(checkbox);
                } else {
                    this.removeItemFromList(checkbox);
                }
            });
            this.updateInput();
        });
    }

    bindCheckboxCheck = () => {
        this.checkboxes.forEach(checkbox => {
            checkbox.addEventListener('click', () => {
                if (checkbox.checked) {
                    this.addItemToList(checkbox);
                } else {
                    this.removeItemFromList(checkbox);
                }
                this.updateInput();
            });
        });
    }

    findInList = (checkbox) => {
        let res = this.selectedData.find(({ id }) => id === checkbox.value);
        return res;
    }

    addItemToList = (checkbox) => {
        const name = checkbox.parentElement.getElementsByTagName("span")[0];
        if (this.findInList(checkbox) === undefined) {
            this.selectedData.push({
                id: checkbox.value,
                name: name.innerText,
            });
        }
    }

    removeItemFromList = (checkbox) => {
        this.selectedData = this.selectedData.filter(data => {
            return data.id !== checkbox.value;
        });
    }

    showCounter = () => {
        const counter = this.input.parentElement.querySelector('.select-counter');

        if (counter) {
            counter.innerText = this.selectedData.length;
        } else {
            const span = document.createElement('span');
            span.classList.add('select-counter');
            span.innerText = this.selectedData.length;
    
            this.input.parentElement.appendChild(span);
        }
    }

    hideCounter = () => {
        this.component.querySelectorAll('.select-counter').forEach(counter => counter.remove());
    }

    getData = () => {
        return this.selectedData;
    }
}